import React, { useContext } from "react";
import "./customForm.styles.scss";
import { useDeleteDestination } from "../../api/mutations/destinationMutations";
import { FormTypes } from "../../utils/formFactory";
import { FormContext } from "../../context/form.context";
import { useDeleteAdventure } from "../../api/mutations/adventureMutations";

const DeleteModal = ({
  title,
  itemName,
  formType,
  handleIsOpen
}) => {
  //   const HandleDestinationUpdate = (id, index) => {
  //     setFormType(FormTypes.UpdateDestination);

  //     const t = { ...dicts[index], destinationId: id };
  //     setInitialFormdata(FormTypes.UpdateDestination, t);
  //     setIsFormOpen(true);
  //   };
  const { adventureId, destinationId } = useContext(FormContext);
  const deleteDestination = useDeleteDestination();
  const deleteAdventure = useDeleteAdventure();

  const HandleIsOpen = () => {
    return handleIsOpen();
  };

  const onSubmit = (event) => {
      event.preventDefault();
  
      switch (formType) {
        case FormTypes.DeleteDestination:
          const data = deleteDestination({ destinationId: destinationId });
          return handleIsOpen();
        case FormTypes.DeleteAdventure:
          const data2 = deleteAdventure({ adventureId: adventureId });
          return handleIsOpen();
          return;
        default:
          throw new Error("not implemented");
      }
    };

  return (
    <>
      <div className="delete-model-component">
        <div className="delete-model-component__title">{title}</div>

        <div>Are you sure you want to delete this {itemName}?</div>

        <div className="delete-model-component__buttons">
          {/* Cancel */}
          <div>
            <button
              className="delete-model-component__buttons__button  delete-model-component__buttons__button__cancel"
              onClick={HandleIsOpen}
            >
              Cancel
            </button>
          </div>

          {/* Delete */}
          <div>
            <button
              className="delete-model-component__buttons__button delete-model-component__buttons__button__delete"
              onClick={onSubmit}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteModal;
